/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type ParticipantNotesQueryVariables = {
    readonly id: string;
};
export type ParticipantNotesQueryResponse = {
    readonly me: ({
        readonly case_manager: ({
            readonly id: string;
            readonly name: {
                readonly first: string;
                readonly last: string | null;
            };
        }) | null;
    }) | null;
    readonly participants: ({
        readonly participant: ReadonlyArray<({
            readonly id: string;
            readonly name: {
                readonly first: string;
                readonly last: string | null;
            };
            readonly notes: ReadonlyArray<({
                readonly id: string;
                readonly label: string;
                readonly created_at: string;
                readonly updated_at: string | null;
                readonly case_manager: ({
                    readonly id: string;
                    readonly name: {
                        readonly first: string;
                        readonly last: string | null;
                    };
                }) | null;
            }) | null> | null;
        }) | null> | null;
    }) | null;
};
export type ParticipantNotesQuery = {
    readonly response: ParticipantNotesQueryResponse;
    readonly variables: ParticipantNotesQueryVariables;
};



/*
query ParticipantNotesQuery(
  $id: String!
) {
  me {
    case_manager {
      id
      name {
        first
        last
      }
    }
  }
  participants(id: $id) {
    participant {
      id
      name {
        first
        last
      }
      notes {
        id
        label
        created_at
        updated_at
        case_manager {
          id
          name {
            first
            last
          }
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "id",
            "type": "String!",
            "defaultValue": null
        } as any)
    ], v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v2 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "name",
        "storageKey": null,
        "args": null,
        "concreteType": "PersonName",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "first",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "last",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v3 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "case_manager",
        "storageKey": null,
        "args": null,
        "concreteType": "CaseManager",
        "plural": false,
        "selections": [
            (v1 /*: any*/),
            (v2 /*: any*/)
        ]
    } as any), v4 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "me",
            "storageKey": null,
            "args": null,
            "concreteType": "Me",
            "plural": false,
            "selections": [
                (v3 /*: any*/)
            ]
        } as any),
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "participants",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "Pagination",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "participant",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Participant",
                    "plural": true,
                    "selections": [
                        (v1 /*: any*/),
                        (v2 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "notes",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ParticipantNote",
                            "plural": true,
                            "selections": [
                                (v1 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "label",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "created_at",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "updated_at",
                                    "args": null,
                                    "storageKey": null
                                },
                                (v3 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "ParticipantNotesQuery",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v4 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "ParticipantNotesQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v4 /*: any*/)
        },
        "params": {
            "operationKind": "query",
            "name": "ParticipantNotesQuery",
            "id": null,
            "text": "query ParticipantNotesQuery(\n  $id: String!\n) {\n  me {\n    case_manager {\n      id\n      name {\n        first\n        last\n      }\n    }\n  }\n  participants(id: $id) {\n    participant {\n      id\n      name {\n        first\n        last\n      }\n      notes {\n        id\n        label\n        created_at\n        updated_at\n        case_manager {\n          id\n          name {\n            first\n            last\n          }\n        }\n      }\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '07347a49ae20afb43964fe7eadda5ed6';
export default node;
